
import styles from './styles.module.css';

interface TextInfoProps {
  label?: string;
  info?: string;
}

const LabeledInfo = ({ label = '', info = '' }: TextInfoProps) => (
  <div className={styles['labeled-info-container']}>
    <p className={styles['labeled-info-label']}>{label}</p>
    <p className={styles['labeled-info-info']}>{info}</p>
  </div>
);

export default LabeledInfo;
